module.exports = __webpack_public_path__ + "static/icons/icon-print-f35e7afa425813d3b34d717ce1c07590.svg";